import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card'
import { SectionHeader } from '../SectionHeader'
import { useTranslation } from '@/hooks/useTranslation'

export const TroubleshootingSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="troubleshooting" className="mb-16">
			<SectionHeader id="troubleshooting">
				{t('docs.troubleshooting.title')}
			</SectionHeader>

			<div className="space-y-6">
				<Card className="shadow-sm dark:bg-gray-800/50">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('docs.troubleshooting.notAppearing.title')}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<ul className="list-disc pl-5 space-y-2 text-sm text-gray-600 dark:text-gray-400">
							<li>
								{t('docs.troubleshooting.notAppearing.item1.prefix')}{' '}
								<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
									YOUR_WIDGET_ID
								</code>{' '}
								{t('docs.troubleshooting.notAppearing.item1.suffix')}
							</li>
							<li>
								{t('docs.troubleshooting.notAppearing.item2.prefix')}{' '}
								<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
									&lt;/body&gt;
								</code>{' '}
								{t('docs.troubleshooting.notAppearing.item2.suffix')}
							</li>
							<li>
								{t('docs.troubleshooting.notAppearing.item3')}
							</li>
							<li>
								{t('docs.troubleshooting.notAppearing.item4')}
							</li>
						</ul>
					</CardContent>
				</Card>

				<Card className="shadow-sm dark:bg-gray-800/50">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('docs.troubleshooting.notResponding.title')}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<ul className="list-disc pl-5 space-y-2 text-sm text-gray-600 dark:text-gray-400">
							<li>
								{t('docs.troubleshooting.notResponding.item1')}
							</li>
							<li>
								{t('docs.troubleshooting.notResponding.item2')}
							</li>
							<li>
								{t('docs.troubleshooting.notResponding.item3')}
							</li>
							<li>
								{t('docs.troubleshooting.notResponding.item4')}
							</li>
						</ul>
					</CardContent>
				</Card>

				<Card className="shadow-sm dark:bg-gray-800/50">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('docs.troubleshooting.consoleErrors.title')}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<ul className="list-disc pl-5 space-y-2 text-sm text-gray-600 dark:text-gray-400">
							<li>
								{t('docs.troubleshooting.consoleErrors.item1')}
							</li>
							<li>
								{t('docs.troubleshooting.consoleErrors.item2')}
							</li>
							<li>
								{t('docs.troubleshooting.consoleErrors.item3')}
							</li>
							<li>
								{t('docs.troubleshooting.consoleErrors.item4')}
							</li>
						</ul>
					</CardContent>
				</Card>
			</div>
		</section>
	)
}